export default "__VITE_ASSET__uSGbjVW4__";